import React from 'react';
import { useTranslation } from 'react-i18next';

export const AccessLibreLink = ({uuid}) => {

  const {t} = useTranslation();

  return (
    <a 
      href="" 
      aria-haspopup="dialog" 
      data-erp-pk={`${uuid}`} 
      aria-controls="dialog"
      style={{
        alignSelf: 'center'
      }}
      role="button" // Provide role for screen readers
    >
      {t('accesslibre.access_libre_label')}
    </a>
  );
};